var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconLuggage = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6.75 3C6.75 2.586 7.086 2.25 7.5 2.25H10.5C10.914 2.25 11.25 2.586 11.25 3V6H12.75C13.9928 6 15 7.00725 15 8.25V18.75C15 19.9928 13.9928 21 12.75 21V21.75C12.75 22.164 12.414 22.5 12 22.5C11.586 22.5 11.25 22.164 11.25 21.75V21H6.75V21.75C6.75 22.164 6.414 22.5 6 22.5C5.586 22.5 5.25 22.164 5.25 21.75V21C4.00725 21 3 19.9928 3 18.75V8.25C3 7.00725 4.00725 6 5.25 6H6.75V3ZM5.25 7.5C4.836 7.5 4.5 7.836 4.5 8.25V18.75C4.5 19.164 4.836 19.5 5.25 19.5H12.75C13.164 19.5 13.5 19.164 13.5 18.75V8.25C13.5 7.836 13.164 7.5 12.75 7.5H5.25ZM9.75 6V3.75H8.25V6H9.75Z", fill: "black" }),
            React.createElement("path", { d: "M18.75 9.75C19.9928 9.75 21 10.7573 21 12V19.5C21 20.7428 19.9928 21.75 18.75 21.75H15.75C15.336 21.75 15 21.414 15 21C15 20.586 15.336 20.25 15.75 20.25H18.75C19.164 20.25 19.5 19.914 19.5 19.5V12C19.5 11.586 19.164 11.25 18.75 11.25H16.5C16.086 11.25 15.75 10.914 15.75 10.5C15.75 10.086 16.086 9.75 16.5 9.75H18.75Z", fill: "black" }))),
        alt: 'Luggage',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconLuggage;
//# sourceMappingURL=index.js.map